import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "col-12 rangeslider" };
const _hoisted_2 = { class: "form" };
const _hoisted_3 = { class: "dx-fieldset" };
const _hoisted_4 = { class: "dx-field custom-height-slider" };
const _hoisted_5 = {
    class: "dx-field-label fw-bold",
    id: "labelRangeSlider"
};
const _hoisted_6 = { class: "dx-field-value" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DxRangeSlider = _resolveComponent("DxRangeSlider");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.datasourceforrange.label), 1),
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_DxRangeSlider, {
                            min: _ctx.datasourceforrange.minvalue,
                            max: _ctx.datasourceforrange.maxvalue,
                            start: _ctx.datasourceforrange.minvalue,
                            end: _ctx.datasourceforrange.maxvalue,
                            step: _ctx.datasourceforrange.step,
                            label: _ctx.createDxLabel(),
                            tooltip: _ctx.createDxTooltip()
                        }, null, 8, ["min", "max", "start", "end", "step", "label", "tooltip"])
                    ])
                ])
            ])
        ])
    ]));
}
